exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrap[data-v-5c23debc]{padding:.2rem}.box[data-v-5c23debc]{box-shadow:0 0 .12rem 0 #efefef;border-radius:.04rem;padding:.3rem}.num[data-v-5c23debc]{background:#f7b55d;color:#fff;border-radius:.04rem;font-size:.2rem;margin-right:.05rem}.state[data-v-5c23debc]{width:2.16rem;height:1.8rem;right:0;top:0}.label[data-v-5c23debc]{width:1.12rem}.text-ovf[data-v-5c23debc]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:0}.cont[data-v-5c23debc]{margin:0 .1rem}.cont-list[data-v-5c23debc]{padding-top:.5rem;padding-left:.44rem;border-left:.04rem solid #efefef}.dian[data-v-5c23debc]{background:#efefef;height:.24rem;width:.24rem;border-radius:50%;margin-left:-.56rem;margin-right:.34rem}.mart80[data-v-5c23debc]{margin-top:.8rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5c23debc","scoped":true,"hasInlineConfig":false}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/planDetail/planDetail.vue
// module id = 292
// module chunks = 0